import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import "swiper/css/navigation";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";

export class ContentImageTextSlider {
    private readonly contentImageTextSlider: NodeListOf<HTMLElement>;
    private readonly isNarrowContent: boolean;

    constructor() {
        this.contentImageTextSlider = document.querySelectorAll(".image-text-slider-section .swiper");
        if (!this.contentImageTextSlider) {
            return;
        }

        this.isNarrowContent = document.body.querySelector(".content-narrow") != null;

        this.initSlider();
    }

    private initSlider = () => {
        this.contentImageTextSlider.forEach((slider) => {
            const swiper = new Swiper(slider, {
                modules: [Navigation],
                slidesPerView: 1.4,
                centeredSlides: true,
                loop: true,
                spaceBetween: 16,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                    672: {
                        spaceBetween: 24,
                        slidesPerView: this.isNarrowContent ? 1.4 : 2.5,
                    },
                },
            });
            
            slider.querySelectorAll(".swiper-slide").forEach((slide, index) => {
                slide.addEventListener("focus", () => {
                    swiper.slideTo(index);
                });
            });
        });
    };
}
